export type FuelItemSlug = 'petrol' | 'lpg' | 'diesel' | 'cng';

export interface FuelItemConfig {
  id: FuelItemSlug;
  label: string;
  imageUrl: string;
  unit: string;
  apiType: 'Petrol' | 'LPG' | 'Diesel' | 'CNG';
}

export const FUEL_ITEMS: FuelItemConfig[] = [
  {
    id: 'petrol',
    label: 'पेट्रोल',
    imageUrl:
      'https://static.inshorts.com/inshorts/images/v1/variants/png/m/2024/07_jul/15_mon/img_1721062022665_988.png?',
    unit: 'kg',
    apiType: 'Petrol',
  },
  {
    id: 'lpg',
    label: 'डोमेस्टिक गैस',
    imageUrl:
      'https://static.inshorts.com/inshorts/images/v1/variants/png/m/2024/07_jul/15_mon/img_1721061986209_878.png?',
    unit: 'kg',
    apiType: 'LPG',
  },
  {
    id: 'diesel',
    label: 'डीज़ल',
    imageUrl:
      'https://static.inshorts.com/inshorts/images/v1/variants/png/m/2024/07_jul/15_mon/img_1721062067418_417.png?',
    unit: 'kg',
    apiType: 'Diesel',
  },
  {
    id: 'cng',
    label: 'सीएनजी',
    imageUrl:
      'https://static.inshorts.com/inshorts/images/v1/variants/png/m/2024/07_jul/15_mon/img_1721062067418_417.png?',
    unit: 'kg',
    apiType: 'CNG',
  },
];

export function getFuelItem(itemId: string) {
  return FUEL_ITEMS.find((item) => item.id === itemId) || null;
}
